module.exports = __webpack_public_path__ + "img/SAFo_SocialMedia_FakeProfiles.22019f8d.svg";